import { invoiceAPI, invoiceAdminAPI, publicAPI } from './api';
import { handleErrMessage, handleSuccess } from './shared';

export async function getReceivableActivitiesInternationalList(page) {
  try {
    const { data } = await invoiceAdminAPI().get(`/invapi/admin/international-access/${page}`, null);

    console.log(data);

    return data;
  } catch (err) {
    handleErrMessage('Unable to fetch receivable activities data. Please try again later.');

    return err;
  }
}

export async function updateReceivableAcitiviesInternationalList(page, id, countries) {
  try {
    const encodedId = encodeURIComponent(id);
    const { data } = await invoiceAdminAPI().put(`/invapi/admin/international-access/${page}/rec-activity/${encodedId}`, {
        countries: countries
    });

    console.log(data);
    handleSuccess("Update Successful")
    return data;
  } catch (err) {
    handleErrMessage('Unable to update international access. Please try again later.');

    return err;
  }
}

export async function getPaymentTilesInternationalList() {
    try {
      const { data } = await invoiceAdminAPI().get(`/invapi/admin/international-access-tiles`, null);
  
      console.log(data);
  
      return data;
    } catch (err) {
      handleErrMessage('Unable to fetch payment tiles data. Please try again later.');
  
      return err;
    }
  }

  export async function getPaymentTileInternationalList(page) {
    try {
      const { data } = await invoiceAPI().get(`/invapi/international-access-tile/${page}`, null);
  
      console.log(data);
  
      return data;
    } catch (err) {
      handleErrMessage('Unable to fetch payment tiles data. Please try again later.');
  
      return err;
    }
  }

  export async function updatePaymentTileInternationalList(page,countries) {
    try {
      const { data } = await invoiceAdminAPI().put(`/invapi/admin/international-access-tile/${page}`, {
        countries: countries
      });
  
      console.log(data);
      handleSuccess("Update Successful")
      return data;
    } catch (err) {
      handleErrMessage('Unable to fetch payment tiles data. Please try again later.');
  
      return err;
    }
  }